import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { BirthInfo } from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: BirthInfo, option) {
    let options: AbstractControlOptions = {};
    let sessionConsultant = option?.sessionConsultant;
    let isCristalisOrganization = option?.isCristalisOrganization;
    let isFinancileProduct = option?.isFinancileProduct;
    let nationalities = [];
    if (entity?.userOtherNationalities?.length) {
      entity?.userOtherNationalities?.forEach(element => {
        nationalities.push(element);
      });
    }

    const zipCodeCondition =
      (isCristalisOrganization && sessionConsultant) ||
      (entity.userBirthCountry && entity.userBirthCountry !== 'FR') ||
      (entity.userBirthLocation && String(entity.userBirthLocation) === '99');

    const form = this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        userLastName: [entity?.userLastName || null],
        userFirstName: [entity?.userFirstName ? entity.userFirstName : null],
        userMajeurCapable: [
          entity?.userMajeurCapable || true,
          Validators.required,
        ],
        userBirthDate: [
          entity ? entity.userBirthDate : null,
          isCristalisOrganization && sessionConsultant
            ? Validators.nullValidator
            : Validators.required,
        ],
        userBirthLocation: [
          entity ? entity.userBirthLocation : null,
          isCristalisOrganization
            ? Validators.nullValidator
            : Validators.required,
        ],
        userBirthZipCode: [
          entity && entity.userBirthZipCode ? entity.userBirthZipCode : null,
          [
            zipCodeCondition && !isFinancileProduct
              ? Validators.nullValidator
              : Validators.compose([
                  Validators.required,
                  Validators.minLength(5),
                  Validators.maxLength(5),
                  Validators.pattern('[0-9]+'),
                ]),
          ],
        ],
        userBirthCountry: [
          entity ? entity.userBirthCountry : null,
          isCristalisOrganization && sessionConsultant
            ? Validators.nullValidator
            : Validators.required,
        ],
        userBirthCity: [
          entity ? entity.userBirthCity : null,
          isCristalisOrganization && sessionConsultant
            ? Validators.nullValidator
            : Validators.required,
        ],
        userNationality: [
          entity ? entity.userNationality : null,
          isCristalisOrganization && sessionConsultant
            ? Validators.nullValidator
            : Validators.required,
        ],
        userOtherNationalities: this.formBuilder.array(nationalities),
      },
      options,
    );

    return form;
  }
  generate(entity: BirthInfo[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }

  extract() {
    return this.form.value.owners;
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
}
